import { Injectable, signal, computed } from '@angular/core';
import { UserConfigurationService } from '../userconfiguration/user-configuration.service';
import { NavigationFilterStateService } from '../navigation-filter-state/navigation-filter-state.service';
import { ScrollService } from '../scroll-service/scroll.service';
import { PlatformService } from '../platform-service/platform.service';

@Injectable({
  providedIn: 'root',
})
export class SideNavigationService {
  public readonly KEY_SIDE_NAVIGATION_OPEN = 'SIDE_NAVIGATION_OPEN';

  private static readonly WIDTH_ANIMATION_MS = 400;

  private _isOpenSideNav = signal<boolean>(true);
  readonly isOpenSideNav = this._isOpenSideNav.asReadonly();

  private _isWidthAnimating = signal<boolean>(false);
  readonly isWidthAnimating = this._isWidthAnimating.asReadonly();
  private widthAnimationTimeoutId?: ReturnType<typeof setTimeout>;

  readonly isNavigationFilterStateOpen = computed(() =>
    this.navigationFilterStateService.menuBarOpen()
  );

  constructor(
    private userConfigurationService: UserConfigurationService,
    private navigationFilterStateService: NavigationFilterStateService,
    private scrollService: ScrollService,
    private platformService: PlatformService
  ) {
    const savedValue = this.userConfigurationService.getOrDefault(
      this.KEY_SIDE_NAVIGATION_OPEN,
      true
    );
    this._isOpenSideNav.set(savedValue);
  }

  isSideNavOpen(): boolean {
    return this._isOpenSideNav();
  }

  toggleSideNav(): void {
    this._isOpenSideNav.update(open => !open);
    this.markWidthAnimating();
    this.updateScrollStateMobile();
    this.userConfigurationService
      .set(this.KEY_SIDE_NAVIGATION_OPEN, this._isOpenSideNav())
      .subscribe();
  }

  openSideNav(): void {
    this._isOpenSideNav.set(true);
    this.markWidthAnimating();
    this.updateScrollStateMobile();
    this.userConfigurationService
      .set(this.KEY_SIDE_NAVIGATION_OPEN, true)
      .subscribe();
  }

  closeSideNav(): void {
    this._isOpenSideNav.set(false);
    this.markWidthAnimating();
    this.updateScrollStateMobile();
    this.userConfigurationService
      .set(this.KEY_SIDE_NAVIGATION_OPEN, false)
      .subscribe();
  }

  checkBehaviorSideNav(): void {
    if (this.isNavigationFilterStateOpen()) {
      this.openSideNav();
    } else {
      this.closeSideNav();
    }
  }

  private updateScrollStateMobile(): void {
    if (this.platformService.isMobile()) {
      this._isOpenSideNav() ? this.scrollService.disableScroll() : this.scrollService.enableScroll();
    }
  }

  private markWidthAnimating(): void {
    this._isWidthAnimating.set(true);
    clearTimeout(this.widthAnimationTimeoutId);
    this.widthAnimationTimeoutId = setTimeout(
      () => this._isWidthAnimating.set(false),
      SideNavigationService.WIDTH_ANIMATION_MS
    );
  }
}
